export default __webpack_public_path__ + "static/media/CafeAvion.bf1a9a84.jpg";